module.exports = __webpack_public_path__ + "img/company7.9c058432.png";